import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ValidatedTextInput } from '@els/els-react--text-input';
import './AlertNameRow.scss';

function AlertNameRow({ alertFormAlertName, setAlertFormAlertName, validateAlertName }) {
  const getValidationResult = useCallback((value) => (validateAlertName ? validateAlertName(value) : true), [validateAlertName]);

  const handleChange = useCallback(
    (valueOrEvent) => {
      const validationResult = getValidationResult(valueOrEvent);
      const isValid = validationResult !== false;
      if (isValid) {
        setAlertFormAlertName(valueOrEvent);
      }
    },
    [getValidationResult, setAlertFormAlertName]
  );

  const resolveAlertNameError = useCallback(
    (valueOrEvent) => {
      const currentValue = valueOrEvent || alertFormAlertName;
      const validationResult = getValidationResult(currentValue);

      if (!validationResult?.isValid) {
        return validationResult.validationMessage;
      }

      return validationResult === false ? 'Invalid alert name' : null;
    },
    [getValidationResult, alertFormAlertName]
  );

  const placeholderText = alertFormAlertName ? 'Name' : 'Choose a name';

  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-name">
      <div className="create-alert-dialog-column-label">Alert name:</div>
      <div className="create-alert-dialog-column-content">
        <ValidatedTextInput
          data-e2e="alert-name-input"
          className="create-alert-name create-alert-name-input"
          label="Alert name"
          shouldHideLabel
          onChange={(event) => {
            handleChange(event.target?.value);
          }}
          value={alertFormAlertName}
          placeholder={placeholderText}
          validator={resolveAlertNameError}
          required
          hideRequired
        />
      </div>
    </div>
  );
}

AlertNameRow.propTypes = {
  alertFormAlertName: PropTypes.string,
  setAlertFormAlertName: PropTypes.func.isRequired,
  validateAlertName: PropTypes.func.isRequired,
};

export default AlertNameRow;
